<template>
  <thead>
    <tr>
      <th class="min-width-170 font-size-0875-rem font-weight-bold text-no-wrap">
        {{ title }}
      </th>
      <th
        v-for="month, index in monthArr"
        class="width-75 px-2 font-size-075-rem text-no-wrap text-right"
        :key="index"
      >
        {{ month }}
      </th>
      <th class="width-80 px-2 font-size-0875-rem text-no-wrap text-right">
        合計
      </th>
    </tr>
  </thead>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue"

export default defineComponent({
  name: "YearlySummaryTableHeader",
  props: {
    headerTitle: {
      type: String,
      required: true
    },
    monthArr: {
      type: Array,
      required: true
    },
  },
  setup(props) {
    const title = computed(() => props.headerTitle as string)
    const monthArr = computed(() => props.monthArr as Array<string>)

    return {
      title,
      monthArr
    }
  }
})
</script>
